import React from 'react';
import { setCurrentView } from 'core/utils';
import { PrintAdditionalDocumentsTemplate } from 'themes/modules/order/pages';
import PrintAdditionalDocumentsViewStore from '../stores/PrintAdditionalDocumentsViewStore';

@setCurrentView(
	(rootStore, componentProps) => new PrintAdditionalDocumentsViewStore(rootStore, componentProps),
	'printAdditionalDocumentsViewStore'
)
class PrintAdditionalDocuments extends React.Component {
	render() {
		return <PrintAdditionalDocumentsTemplate {...this.props} />;
	}
}

export default PrintAdditionalDocuments;
